import { render, staticRenderFns } from "./EmbeddedVideo.vue?vue&type=template&id=75b7336b&scoped=true"
import script from "./EmbeddedVideo.vue?vue&type=script&lang=js"
export * from "./EmbeddedVideo.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedVideo.vue?vue&type=style&index=0&id=75b7336b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b7336b",
  null
  
)

export default component.exports